import TransferWithinAStationIcon from "@mui/icons-material/TransferWithinAStation";
import PushPinIcon from "@mui/icons-material/PushPin";
import {
  AccordionDetails,
  Box,
  Button,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Grid,
  IconButton,
  Tooltip,
  Typography,
} from "@mui/material";

import moment from "moment";
import React, { useState } from "react";
import { useSelector } from "react-redux";
import { ContainedGreenButton } from "../../../components/buttons";
import { USER_ROLE } from "../../../utils/constant";
import {
  downloadDocument,
  downloadEmailDocument,
  getModifiedFileName,
} from "../../../utils/util";
import TransferEmailDialog from "./TransferEmailDialog";
import EmailWithStatus from "./EmailWithStatus";

const InstructionSingleEmail = ({
  emailData = {},
  showFullEmail = false,
  setShowFullEmail = false,
  clientData,
  isClientEmail = false,
}) => {
  const [isEmailTransfer, setIsEmailTransfer] = useState(false);
  const [selectedEmail, setSelectedEmail] = useState(null);
  const handleClickEmailTransper = (data) => {
    setSelectedEmail(data);
    setIsEmailTransfer(true);
  };
  return (
    <>
      {isEmailTransfer && (
        <TransferEmailDialog
          open={isEmailTransfer}
          handleClose={() => setIsEmailTransfer(false)}
          selectedEmail={selectedEmail}
        />
      )}
      <Grid>
        {/* Dialogue to show full mail */}
        <Dialog
          open={showFullEmail}
          onClose={() => setShowFullEmail(false)}
          maxWidth={"md"}
          fullWidth
          scroll="paper"
          id="instruction-email"
        >
          <DialogTitle
            style={{ textAlign: "center" }}
            className="serif_display_regular_26 green"
          >
            Email
          </DialogTitle>
          <DialogContent p={2}>
            <Grid item xs={12} direction={"column"} container rowSpacing={2}>
              <Grid item>
                <Typography className="normal_normal_600_14_Manrope green">
                  From
                </Typography>
                <Typography className="normal_normal_600_14_Manrope dark_grey">
                  {emailData?.from || "NA"}
                </Typography>

                <Typography className="normal_normal_600_14_Manrope">
                  {moment(new Date(emailData?.createdAt))?.format(
                    "DD/MM/YY hh:mm A"
                  )}
                </Typography>
              </Grid>
              <Grid item>
                <Typography className="normal_normal_600_14_Manrope green">
                  To
                </Typography>
                <Typography className="normal_normal_600_14_Manrope">
                  {emailData?.to?.join(", ")}
                </Typography>
              </Grid>
              <Grid item>
                <Typography className="normal_normal_600_14_Manrope green">
                  Subject
                </Typography>
                <Typography
                  className=" normal_normal_600_14_Manrope dark_grey"
                  component={"span"}
                >
                  {emailData?.subject}
                </Typography>
              </Grid>
              <Grid item>
                <Typography className="normal_normal_600_14_Manrope green">
                  Message
                </Typography>
                <Box dangerouslySetInnerHTML={{ __html: emailData?.html }} />
              </Grid>
              <Grid item>
                <Typography className="normal_normal_600_14_Manrope green">
                  Attachments
                </Typography>

                {emailData?.attachments?.length > 0 && (
                  <>
                    {emailData?.attachments?.map((file, j) => {
                      return (
                        <Chip
                          style={{ marginRight: "10px" }}
                          key={`attachment${j}`}
                          label="Attachment"
                          onClick={() => downloadEmailDocument(file)}
                        />
                      );
                    })}
                  </>
                )}

                {emailData?.InstructionTaskDocuments?.length ? (
                  <Box paddingBottom={1}>
                    <hr />
                    <Box display={"flex"} columnGap={1} pt={1} gap={1}>
                      {emailData?.InstructionTaskDocuments?.map((file, j) => {
                        return (
                          <Chip
                            key={`attachment${j}`}
                            label={
                              file?.fileInfo?.modifiedFileName ||
                              getModifiedFileName(file?.documentUrl) ||
                              "NA"
                            }
                            onClick={() =>
                              downloadDocument(file, clientData, "")
                            }
                          />
                        );
                      })}
                    </Box>
                  </Box>
                ) : (
                  ""
                )}
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions sx={{ p: 2, borderTop: "1px solid" }}>
            <ContainedGreenButton
              onClick={() => setShowFullEmail(false)}
              label={"OK"}
            />
          </DialogActions>
        </Dialog>
      </Grid>
    </>
  );
};

export default InstructionSingleEmail;
